import {createSlice} from '@reduxjs/toolkit';
import {FormProductTypeInit} from "./model";
const R = require('ramda');

const initialState = {
    productTypeForm: FormProductTypeInit,
    attributes: [],

};

const productTypeSlice = createSlice({
    name: 'productType',
    initialState,
    reducers: {
        initProductTypeForm: (state, action) => {
            state.productTypeForm = FormProductTypeInit
        },
        onProductTypeFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.productTypeForm[name] = value;
        },
        setAttributes: (state, action) => {
            state.attributes = action.payload
        }
    },
});

export const {actions} = productTypeSlice;
export const {
    initProductTypeForm,
    onProductTypeFormChange,
    setAttributes
} = actions;

// reducers

// selectors
export const selProductTypeForm = (state) => state.productType.productTypeForm;
export const selAttributes = (state) => state.productType.attributes;


const productTypeReducer = {
    productType: productTypeSlice.reducer,
};
export default productTypeReducer;
